module.exports = require('../../es/array/find');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/array/find.js
// module id = 397
// module chunks = 45